componentRegistryInstance.register('spinner', 'edit', 'hrd.components.form.SpinnerComponent');

hrd.components.form.SpinnerComponent = hrd.components.AbstractFieldComponent.extend({
	init: function(options) {
		var defaults = {
			impl: 'hrd.components.form.SpinnerComponent',
		};
		this._super($.extend(true, {}, defaults, options));
	},
	enhanceEditField: function(field, id, klass) {
		this._super(field, id, klass);
		// TODO: Fix Layout
		field.spinner({
			min: field.data('spinner-min') == undefined ? null : field.data('spinner-min'),
			max: field.data('spinner-max') || null,
			step: field.data('spinner-step') || 1,
			numberFormat: field.data('spinner-number-format') || null
		});
		// behaves like an integer
		var seps = this.utils().number().separators();
		var opts = {
			aSep: '', // removed grouping separator for integers...
			aDec: seps.decimal,
			vMax: '2147483647', //java 'MAX_INT'
			mDec: '0'
		}
		if(field.data('spinner-min') !== undefined){
			opts.vMin = '' + field.data('spinner-min');
		}
		if(field.data('spinner-max') !== undefined){
			opts.vMax = '' + field.data('spinner-max');
		}
		field.autoNumeric('init', opts);
		field.addClass('right-align');
		if(field.data('exactWidth')){
			var w = field.data('exactWidth');
			field.parent().css({
				width: w,
				minWidth: w,
				maxWidth: w
			});
			field.css({
				width: '',
				minWidth: '',
				maxWidth: ''
			});
		}
	},
	initalizeComponent: function(field, initialValue) {
		field.autoNumeric('set', initialValue);
	}
});